/**
 * LearningApiClient -- HTTP client for /api/v1/learning.
 * Questions, progress tracking for the learning system.
 *
 * @module infrastructure/api/LearningApiClient
 */

import { ApiBase } from './ApiBase.js';

const BASE = '/api/v1/learning';

export const LearningApiClient = {
  async getQuestions({ category, limit = 20, random = true } = {}) {
    const params = new URLSearchParams();
    if (category) params.set('category', category);
    params.set('limit', limit);
    params.set('random', random);
    return ApiBase.get(`${BASE}/questions?${params}`);
  },

  async recordProgress({ userId, questionId, isCorrect, businessId, context = 'publicidad' }) {
    return ApiBase.post(`${BASE}/progress`, { userId, questionId, isCorrect, businessId, context });
  },

  async getProgressSummary(userId) {
    const q = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    return ApiBase.get(`${BASE}/progress/summary${q}`);
  },

  async getSkills() {
    return ApiBase.get(`${BASE}/skills`);
  },

  async getSkillProgress(userId) {
    const q = userId ? `?user_id=${encodeURIComponent(userId)}` : '';
    return ApiBase.get(`${BASE}/skills/progress${q}`);
  },

  async getPensum() {
    return ApiBase.get(`${BASE}/pensum`);
  },

  async createQuestion(data) {
    return ApiBase.post(`${BASE}/questions`, data);
  },

  async updateQuestion(id, data) {
    return ApiBase.put(`${BASE}/questions/${id}`, data);
  },

  async deleteQuestion(id) {
    return ApiBase.del(`${BASE}/questions/${id}`);
  },

  async getTopics(skillCode) {
    const q = skillCode ? `?skill_code=${encodeURIComponent(skillCode)}` : '';
    return ApiBase.get(`${BASE}/topics${q}`);
  }
};
